import { Position } from "../../../config/interactive/types";
import { mapPosToStyle } from "../utils";
import styles from "./interactiveComponent.module.css";

type props = {
	position: Position;
	src: string;
	isFocused: boolean;
};
export default function IconOnFocus({ position, src, isFocused }: props) {
	return (
		<>
			{isFocused && (
				<div
					style={{
						...mapPosToStyle(position),
					}}
					className={styles.iconContainer}
				>
					<img className={styles.icon} src={src}></img>
				</div>
			)}
		</>
	);
}
